import React from "react";
import Countries from "../Apm/Country/Countries";

const AllCountries = () => {
  return <Countries />;
};

export default AllCountries;
